import ClientDetailsEditField from './ClientDetailsEditField';

export default ClientDetailsEditField;
